import { Alert, Box, Typography } from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { Button } from 'Common/Supplyvue-ui'
import { FONT_SANS, TOKENS } from './SchedulerDesign'

/**
 * Info banner shown above a read-only "source data" table whose values are
 * authored elsewhere (the Rules & Constraints workbench). Cross-links to the
 * tab that owns authoring for this data.
 */
export const ManagedSourceBanner = ({
  label,
  onOpen,
}: {
  label: string
  onOpen: () => void
}) => (
  <Alert
    severity="info"
    icon={false}
    sx={{
      mb: 1.5,
      py: 0.25,
      bgcolor: TOKENS.blue50,
      borderLeft: `3px solid ${TOKENS.brandBlue}`,
      borderRadius: 1,
      alignItems: 'center',
      '& .MuiAlert-message': { width: '100%' },
    }}
  >
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 1.5, width: '100%' }}
    >
      <Typography
        sx={{ fontSize: 12.5, color: TOKENS.ink700, fontFamily: FONT_SANS }}
      >
        This is source data. Values are authored as rules in{' '}
        <strong>{label}</strong> — edit them there to keep one source of truth.
      </Typography>
      <Box sx={{ flex: 1 }} />
      <Button
        variant="contained"
        color="primary"
        size="small"
        endIcon={<ArrowForwardIcon sx={{ fontSize: 16 }} />}
        onClick={onOpen}
        sx={{
          fontSize: '0.72rem',
          py: 0.4,
          px: 1.25,
          whiteSpace: 'nowrap',
          minWidth: 0,
        }}
      >
        Edit in {label}
      </Button>
    </Box>
  </Alert>
)
